"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAcceptedNotification = clearAcceptedNotification;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("../button"));

require("./cookie-notification.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ACCEPTED_FLAG = '_gf_cookies_accepted_';
var OPEN_DELAY = 2000;
/**
 * Helper to store flag that user has seen the notification (acknowledged)
 */

function setAcceptedNotification() {
  window.localStorage.setItem(ACCEPTED_FLAG, 'true');
}
/**
 * Helper to retrieve whether user has accepted notification before.
 * @returns {boolean} True if accepted, false if not.
 */


function hasAcceptedNotification() {
  // on server, don't render yet
  if (typeof window === 'undefined') {
    return false;
  } // coerce to boolean


  return !!window.localStorage.getItem(ACCEPTED_FLAG);
}
/**
 * Helper function to clear the accepted flag. Used for
 * the storybook environment for dev purposes, though could be
 * useful for future use cases.
 */


function clearAcceptedNotification() {
  window.localStorage.removeItem(ACCEPTED_FLAG);
}
/**
 * Click handler for cookie notification.
 */


function acknowledgeCookieNotification() {
  // GTM event
  setAcceptedNotification();
}

var CookieNotification = function CookieNotification(_ref) {
  var text = _ref.text,
      ctaProps = _ref.ctaProps,
      hidden = _ref.hidden,
      ctaText = _ref.ctaText;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; // Show cookie notification if accepted flag is not set


  (0, _react.useEffect)(function () {
    if (!hasAcceptedNotification()) {
      var timeout = setTimeout(function () {
        return setOpen(true);
      }, OPEN_DELAY);
      return function () {
        return clearTimeout(timeout);
      };
    }

    return function () {};
  }, []);
  var classnames = (0, _classnames["default"])('CookieNotification', {
    hidden: hidden,
    open: open
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classnames
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "notification-text"
  }, text), /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({}, ctaProps, {
    className: "notification-cta",
    onClick: function onClick() {
      acknowledgeCookieNotification();
      setOpen(false);
    }
  }), ctaText));
};

CookieNotification.propTypes = {
  ctaProps: _propTypes["default"].shape({}),
  ctaText: _propTypes["default"].node,
  text: _propTypes["default"].node,
  hidden: _propTypes["default"].bool
};
CookieNotification.defaultProps = {
  ctaProps: {},
  ctaText: null,
  text: null,
  hidden: false
};
var _default = CookieNotification;
exports["default"] = _default;